<template>
  <!-- 详细信息弹窗 -->
  <div class="showCon">
    <van-popup class="showD" v-model="showModel">
      <div class="content">
        <!-- <div class="circle"></div> -->
        <div class="ti">收费详情</div>
        <div class="cont">
          <!-- <van-divider hairline style="background: #999" /> -->
          <div
            v-show="detailData.length > 0"
            class="pad"
            v-for="(item, index) in detailData"
            :key="index"
          >
            <div class="deta">
              <span class="t_left">{{ item.label }} </span>
              <div class="right_con"><span>
                {{ item.value }}
              </span></div>
            </div>
          </div>
          <van-divider
            v-show="detailList.length > 0"
            hairline
            style="background: #999"
          />
          <div
            class="pad"
            v-show="detailList.length > 0"
            v-for="item in detailList"
            :key="item.uId"
          >
            <div class="look">
              <span class="t_left">收费项目</span>
               <div class="right_con"><span>{{ item.itemName }}</span></div>
            </div>
            <div class="look">
              <span class="t_left ">金额</span>
              <!-- class="itemmoney" -->
               <div class="right_con"><span >{{ item.actualAmt }}元</span></div>
            </div>
          </div>
          <div style="padding-bottom:20px;"></div>
        </div>
        <div class="close" @click="closeDialog">
          X
        </div>
      </div>
    </van-popup>
    
  </div>
</template>

<script>
import { Notify } from "vant";
export default {
  props: ["info", "isShowDetail", "vde"],
  data() {
    return {
      showModel: false,
      detailData: [],
      dictionaryObj: {},
      showField: false,
      fieldList: [],
      detailList: [],
      notFileNum: 0,
    };
  },
  watch: {
    isShowDetail: {
      deep: true,
      handler(newV, oldV) {
        if (newV) {
          this.handleInfo();
          this.showModel = true;
        }
      },
    },
  },
  methods: {
    handleInfo() {
      this.detailData = [];
      // let showFieldList = this.info.showFieldList;
      this.detailList = this.info.items;
      this.detailData = [
        { label: "执收单位", value: this.info.deptName },
        { label: "缴费单位/人", value: this.info.paymentUnit },
        { label: "证件号码", value: this.info.idCard },
        { label: "总金额", value: this.info.paymentTotal + "元" },
        { label: "缴费日期", value: this.info.confirmDate},
      ];
    },
    getDictionary(dicName, deptDicName) {
      let newDicName = Array.from(new Set(dicName));
      let newDeptDicName = Array.from(new Set(deptDicName));
      let promiseArr = [];
      newDicName.forEach((dictionary) => {
        if (this.dictionaryObj[dictionary] == undefined) {
          promiseArr.push(
            new Promise((resolve) => {
              this.request({
                url: "/system/dictionary/listDictData/" + dictionary,
                method: "get",
              }).then((res) => {
                this.$set(this.dictionaryObj, dictionary, res.data.result);
                resolve();
              });
            })
          );
        }
      });
      newDeptDicName.forEach((dictionary) => {
        if (this.dictionaryObj[dictionary] == undefined) {
          promiseArr.push(
            new Promise((resolve) => {
              this.request({
                url: "/system/dictDeptData/listDictDeptData",
                method: "get",
                params: {
                  deptId: this.vde,
                  dictType: dictionary,
                },
              }).then((res) => {
                this.$set(this.dictionaryObj, dictionary, res.data.result);
                resolve();
              });
            })
          );
        }
      });

      Promise.all(promiseArr).then((res) => {
        let showFieldList = this.info.showFieldList;
        showFieldList.forEach((item) => {
          if (this.dictionaryObj[item.dictionary]) {
            let bool = this.dictionaryObj[item.dictionary].some((val) => {
              if (val.value == this.info[item.fieldName]) {
                let obj = {
                  label: item.showName,
                  value: val.label,
                };
                let flag = this.detailData.every((item) => {
                  return item.label != obj.label;
                });
                if (flag) {
                  this.detailData.push(obj);
                }
                return true;
              } else {
                return false;
              }
            });
            if (bool == false) {
              let obj = {
                label: item.showName,
                value: "",
              };
              let flag = this.detailData.every((item) => {
                return item.label != obj.label;
              });
              if (flag) {
                this.detailData.push(obj);
              }
            }
          }
        });
      });
    },
    closeDialog() {
      this.showModel = false;
      this.$emit("closeDialog");
    },
    getUrl(id) {
      this.request({
        url: "/business/showFile",
        method: "post",
        params: {
          dataId: id,
        },
      }).then((res) => {
        if (res.data.code == 1000) {
          this.fieldList = res.data.result;
          if (this.fieldList.length == 1) {
            window.location.href = this.fieldList[0].fileUrl;
          } else {
            this.showField = true;
          }
        } else {
          Notify({ type: "danger", message: res.data.message });
        }
      });
    },
    openUrl(url) {
      window.open(url);
    },
  },
};
</script>

<style lang='scss' scoped>
.cont {
  max-height: 300px;
  overflow-y: scroll;
  .pad {
    padding: 3px 24px;
    font-size: 14px;
    .itemmoney{
      font-size: 15px;
      color: #F04646;
      font-weight: 600;
    }
  }
  .t_left{
    width:100px;
    word-break: break-all;
    color: #777;
  }
  .right_con{
    width: 170px;
    word-break: break-all;
    text-align: left;
  }
}
.ti {
  margin-bottom: 18px !important;
  text-align: center;
  // position: absolute;
  // top: 4%;
  // left: 50%;
  // z-index: 1001;
  // width: 86%;
  // transform: translateX(-50%);
  font-size: 16px;
  color: #fff;
  padding: 12px 0px;
  border-radius:8px 8px 0px 0px;
  background: rgb(100,164,255);
  ::v-deep .van-divider {
    margin: 10px 0px !important;
    background: rgb(235, 235, 235) !important;
  }
}
.deta {
  display: flex;
  justify-content: space-between;
}
.showCon{
  ::v-deep .van-overlay{
    background-color: transparent;
  }
}
.showD {
  position: fixed;
  z-index: 1000;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.7);
  top: 0%;
  left: 50%;
  transform: translateX(-50%);
}
.close {
  position: absolute;
  bottom: -70px;
  left: 50%;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  font-size: 18px;
  font-weight: 600;
  background: #fff;
  border-radius: 50%;
  transform: translateX(-50%);
  color: #1989fa;
}
.circle {
  width: 80px;
  height: 80px;
  background: #fff;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -30%);
  border-radius: 50%;
  z-index: -1;
}
.dialogTitle {
  .van-dialog__header {
    background: #1989fa;
    color: #fff;
    padding: 10px 0 !important;
    font-weight: 600 !important;
  }
}
.content {
  border-radius: 8px;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 80%;
  max-height: 52%;
  transform: translate(-50%, -50%);
  background: #fff;
  text-align: left;
  line-height: 24px;
  padding: 15px 0px;
  padding-top: 0px;
  > div {
    margin-bottom: 8px;
  }
  ::v-deep .van-divider {
    background: rgb(235, 235, 235) !important;
  }
}
.btn {
  margin-left: 10px;
}
.fildBox {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.fieldListBox {
  padding: 20px;
}
.title {
  background: #1989fa;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  font-size: 16px;
}
.fieldItem {
  font-size: 18px;
  height: 35px;
  line-height: 35px;
  border-bottom: 1px solid #ebedf0;
  display: flex;
  align-items: center;
  span {
    margin-left: 5px;
  }
}
.look {
  display: flex;
  justify-content: space-between;
}
</style>